import { DisclosureType } from '@mortgage-pos/types/generated/graphql-types'

export const disclosureQuestionNameMap = {
  affiliatedBusinessArrangementDisclosure: [
    DisclosureType.AffiliatedBusinessArrangement,
  ],
  authorizationConsent: [
    DisclosureType.TcpaTransactionalConsent,
    DisclosureType.TermsOfUse,
    DisclosureType.PrivacyPolicy,
    DisclosureType.Glba,
    DisclosureType.ElectronicConsent,
    DisclosureType.AffiliatedBusinessArrangement,
    DisclosureType.TransUnionSoftCreditConsent,
  ],
  // Use for control flow
  authorizationWithoutCreditConsent: [
    DisclosureType.TermsOfUse,
    DisclosureType.PrivacyPolicy,
    DisclosureType.Glba,
    DisclosureType.ElectronicConsent,
    DisclosureType.AffiliatedBusinessArrangement,
  ],
  marketingConsent: [DisclosureType.TcpaMarketingAndCustomerCareConsent],
  termsAndCreditAuthorization: [DisclosureType.CreditAuthorization],
  termsOfUsePrivacyPolicyAndElectronicConsentAgreement: [
    DisclosureType.ElectronicConsent,
    DisclosureType.PrivacyPolicy,
    DisclosureType.TermsOfUse,
  ],
  tcpaDisclosure: [DisclosureType.TcpaTransactionalConsent],
  // Fallback for missed edited flows in Storyblok
  tcpaDisclosureSmsOptIn: [DisclosureType.TcpaMarketingAndCustomerCareConsent],
  coBorrowerGlbaDisclosureConsent: [DisclosureType.Glba],
  coBorrowerTcpaDisclosure: [DisclosureType.TcpaTransactionalConsent],
  coBorrowerTcpaDisclosureSmsOptIn: [
    DisclosureType.TcpaMarketingAndCustomerCareConsent,
  ], // Fallback for missed edited flows in Storyblok
  coBorrowerMarketingConsent: [
    DisclosureType.TcpaMarketingAndCustomerCareConsent,
  ],
  coBorrowerSoftCreditConsentDisclosure: [DisclosureType.SoftCreditConsent],
  coBorrowerTransUnionSoftCreditConsentDisclosure: [
    DisclosureType.TransUnionSoftCreditConsent,
  ],
  coBorrowerTermsOfUsePrivacyPolicyAndElectronicConsentAgreement: [
    DisclosureType.ElectronicConsent,
    DisclosureType.PrivacyPolicy,
    DisclosureType.TermsOfUse,
  ],
  coBorrowerAuthorizationConsent: [
    DisclosureType.TcpaTransactionalConsent,
    DisclosureType.TermsOfUse,
    DisclosureType.PrivacyPolicy,
    DisclosureType.Glba,
    DisclosureType.ElectronicConsent,
    DisclosureType.AffiliatedBusinessArrangement,
    DisclosureType.TransUnionSoftCreditConsent,
  ],
  coBorrowerAuthorizationWithoutCreditConsent: [
    DisclosureType.TermsOfUse,
    DisclosureType.PrivacyPolicy,
    DisclosureType.Glba,
    DisclosureType.ElectronicConsent,
    DisclosureType.AffiliatedBusinessArrangement,
  ],
  softCreditConsentDisclosure: [DisclosureType.SoftCreditConsent],
  bankrateProAgentSharingConsent: [
    DisclosureType.BankrateProAgentSharingConsent,
  ],
  transUnionSoftCreditConsentDisclosure: [
    DisclosureType.TransUnionSoftCreditConsent,
  ],
  nonTcpaContactConsent: [DisclosureType.NonTcpaContactConsent],
  coBorrowerNonTcpaContactConsent: [DisclosureType.NonTcpaContactConsent],
  glbaDisclosureConsent: [DisclosureType.Glba],
}
